import { isEmpty } from 'lodash';
import { capitalizeFirstLetter, getCountyNameFromIncludes } from 'utils/custom';
import moment from 'moment';
import FILTER_OPTIONS from '_constants/old/_constants/filters/FILTER_OPTIONS';

const getFormattedDate = (date) => (isEmpty(date) ? null : moment(date).format('MM/DD/YYYY'));

const getStoreType = (type) => {
  const storeType = FILTER_OPTIONS.STORE_TYPE_OPTIONS.find(({ value }) => value === type);
  if (!storeType) {
    return null;
  }
  return isEmpty(type) ? null : storeType.label;
};

const getAddress = (address, address2) => {
  if (address2) {
    return `${address}, ${address2}`;
  }
  return address;
};

const getFilteredCampaignSet = (campaigns) => {
  return campaigns.data.map((item) => Number(item.id));
};

export default (data, included) => {
  const retailers = data.map((item) => {
    const { attributes, relationships } = item;
    const {
      name,
      address,
      address2,
      city,
      zipcode,
      county_name: countyName,
      phone,
      violation_status: violation,
      cdph_business_type: businessType,
      age_restricted_flag: ageRestrictedFlag,
      closed_date: closedDate,
      tobacco,
      pharmacy,
      address_residential: residential,
      latlong,
      address_validated: addressValidated,
      violation_found: violationFoundAz,
      atcc,
      synar_year: synarYear,
    } = attributes;

    const {
      aggregationpolygon_set: secGeogs = { meta: {}, data: [] },
      campaign_set: campaignSet = { meta: {}, data: [] },
    } = relationships || {};

    const retailerItem = {
      id: item.id,
      name: capitalizeFirstLetter(name),
      address: getAddress(address, address2),
      city,
      zipcode,
      county_name: countyName || getCountyNameFromIncludes({ included, secGeogs }),
      phone,
      violation,
      violation_found: violationFoundAz,
      cdph_business_type: getStoreType(businessType),
      age_restricted_flag: ageRestrictedFlag,
      closed_date: getFormattedDate(closedDate),
      tobacco,
      pharmacy,
      sec_geogs: secGeogs,
      campaignSet: getFilteredCampaignSet(campaignSet),
      residential,
      latlong,
      addressValidated,
      atcc: atcc?.join(),
      synarYear,
    };
    return retailerItem;
  });

  return retailers;
};
